import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-can-match",
  "use": "icon-soc-can-match-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-can-match\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"160\" y=\"352\" width=\"288\" height=\"320\" rx=\"32\" /><rect x=\"576\" y=\"352\" width=\"288\" height=\"320\" rx=\"32\" /><path d=\"M448 448h128v128H448z\" /><path d=\"M224 288h64v64h-64zM736 288h64v64h-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-can-match.svg
// module id = 3hE4
// module chunks = 488